import { ff } from '@atlassian/jira-feature-flagging';

export const isEpicLinkFieldRenamedToParent = () =>
	ff('rename-epic-link-field-to-parent-in-gic-epic-renaming-beta_pwfm1', false);
